import { useQuery } from '@tanstack/react-query';
import { getTransparencyExpenses, getTransparencySummary, getTransparencyCategories } from '../services/transparency.service';

/**
 * Hook to fetch public transparency expenses
 * @param {Object} params - Query parameters
 */
export const useTransparencyExpenses = (params = {}) => {
  return useQuery({
    queryKey: ['transparency', 'expenses', params],
    queryFn: () => getTransparencyExpenses(params),
    staleTime: 1000 * 60 * 5,
  });
};

/**
 * Hook to fetch public transparency summary
 */
export const useTransparencySummary = () => {
  return useQuery({
    queryKey: ['transparency', 'summary'],
    queryFn: getTransparencySummary,
    staleTime: 1000 * 60 * 5,
  });
};

/**
 * Hook to fetch public categories (no auth required)
 */
export const useTransparencyCategories = () => {
  return useQuery({
    queryKey: ['transparency', 'categories'],
    queryFn: getTransparencyCategories,
    staleTime: 1000 * 60 * 30,
  });
};
